export default function getStatus<T extends Record<string, unknown>>(obj: T, name: string) {
  const properties = Object.keys(obj).filter((item) => item.indexOf(name) === 0);
  return properties.map((property) => obj[property]).every((item) => item === false);
}
